(function () {
  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        viewTransition.skipTransition();
      }, { once: true });
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }
})();


/* ADONAI_RUNTIME_MOBILE_POLISH_FALLBACK_20260510 */
(() => {
  const css = "\n    .adonai-refresh .adonai-actions .adonai-button--secondary,\n    .adonai-refresh .adonai-actions .adonai-button--mission {\n      display: inline-flex !important;\n      align-items: center !important;\n      justify-content: center !important;\n      border-radius: 999px !important;\n      background: #82482c !important;\n      color: #f7f1e6 !important;\n      border: 1px solid rgba(130,72,44,.28) !important;\n      box-shadow: 0 18px 44px rgba(130,72,44,.18) !important;\n      padding: .9rem 1.35rem !important;\n      min-height: 46px !important;\n      text-decoration: none !important;\n      font-weight: 800 !important;\n    }\n    .adonai-refresh .adonai-hero__proof span {\n      background: transparent !important;\n      border: 0 !important;\n      box-shadow: none !important;\n      padding: 0 !important;\n      width: auto !important;\n    }\n    @media screen and (max-width: 749px) {\n      header-drawer .menu-drawer__featured-content,\n      header-drawer .menu-drawer__featured-content-list,\n      header-drawer .menu-drawer__featured-content-list-item {\n        display: none !important;\n        visibility: hidden !important;\n        height: 0 !important;\n        overflow: hidden !important;\n      }\n      header-drawer .menu-drawer {\n        min-height: 100dvh !important;\n        height: 100dvh !important;\n        background: #f7f1e6 !important;\n        overflow-y: auto !important;\n        padding-bottom: max(2rem, env(safe-area-inset-bottom)) !important;\n      }\n    }\n  ";
  const install = () => {
    if (document.getElementById('adonai-runtime-mobile-polish-fallback')) return;
    const style = document.createElement('style');
    style.id = 'adonai-runtime-mobile-polish-fallback';
    style.textContent = css;
    document.head.appendChild(style);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, { once: true });
  else install();
})();
